<template>
  <div id="redPacketList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>微信红包找零报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       @change="loadPark"
                       style="width:200px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="场库::">
            <el-select v-model="pageSearch.fParkID"
                       filterable
                       placeholder="请选择场库"
                       style="width:200px;"
                       clearable>
              <el-option v-for="item in park_list"
                         :key="item.fParkID"
                         :label="item.fParkName"
                         :value="item.fParkID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号码::">
            <el-input placeholder="请输入车牌号码"
                      v-model="pageSearch.fPlateCode"
                      class="search"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!-- <el-form-item label="支付方式::">
            <el-select v-model="pageSearch.fPayTypeID"
                       clearable
                       filterable
                       placeholder="请选择支付方式"
                       style="width:200px;">
              <el-option v-for="(e, i) in payType_list"
                         :key="i"
                         :label="e.fOuterName"
                         :value="e.fPayTypeID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付模式::">
            <el-select v-model="pageSearch.fPayMode"
                       clearable
                       filterable
                       placeholder="请选择支付模式"
                       style="width:200px;">
              <el-option v-for="item in payMode_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="date"
                            :clearable="false"
                            :picker-options="startMonthOption"
                            @change="selectStartMonth"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            type="date"
                            :picker-options="endMonthOption"
                            @change="selectEndMonth"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="红包状态::">
            <el-select v-model="pageSearch.fPayStatus"
                       clearable
                       filterable
                       placeholder="请选择红包状态"
                       style="width:200px;">
              <el-option v-for="item in payStatus_list"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  :summary-method="getSummaries"
                  ref="dt"
                  show-summary
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fOpLastTime"
                           width="160"
                           label="创建时间">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <!-- <el-table-column prop="fParkNo"
                           width="80"
                           label="场库编号">
          </el-table-column> -->
          <el-table-column prop="fParkName"
                           width="100"
                           label="场库名称">
          </el-table-column>
          <el-table-column prop="fOutChnlName"
                           width="100"
                           label="通道名称">
          </el-table-column>
          <el-table-column prop="fBusOrderNo"
                           width="280"
                           label="商户订单号">
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="100"
                           label="车牌">
          </el-table-column>
          <el-table-column prop="fInTime"
                           width="150"
                           label="进场时间">
          </el-table-column>
          <el-table-column prop="fOutTime"
                           width="150"
                           label="出场时间">
          </el-table-column>
          <el-table-column prop="fCalcAmt"
                           width="98"
                           align="right"
                           label="计费金额(元)">
          </el-table-column>
          <el-table-column prop="fPayAmt"
                           width="98"
                           align="right"
                           label="支付金额(元)">
          </el-table-column>
          <el-table-column prop="fChgAmt"
                           width="98"
                           align="right"
                           label="找零金额(元)">
          </el-table-column>
          <el-table-column prop="fPayStatusName"
                           width="80"
                           label="支付状态">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="160">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="primary"
                         @click="handleDetail(scope.$index, scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <roadSideCarInfoView ref="child"
                         :type="2"
                         v-if="is_roadSide"></roadSideCarInfoView>
    <carInfoView ref="child"
                 v-else
                 reportActiveName="pageData"
                 :isNeedCustIdSearch="true"
                 :type="2"></carInfoView>
    <el-dialog :title="dialogTitle"
               width="55%"
               top="7vh"
               v-loading="true"
               :visible.sync="dialogVisible"
               v-dialogDrag>
      <el-form label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="最后操作时间">
              <el-input v-model="form.fOpLastTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户编号">
              <el-input v-model="form.fCustNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务器IP">
              <el-input v-model="form.fSvrIPAddr"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="商户订单号">
              <el-input v-model="form.fBusOrderNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付订单号">
              <el-input v-model="form.fPayOrderNo"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="业务数据编号">
              <el-input v-model="form.fBusID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="进场时间">
              <el-input v-model="form.fInTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="场库名称">
              <el-input v-model="form.fParkName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="通道名称">
              <el-input v-model="form.fOutChnlName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="出场时间">
              <el-input v-model="form.fOutTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌号码">
              <el-input v-model="form.fPlateCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="微信openid">
              <el-input v-model="form.fOpenID"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="计费金额">
              <el-input v-model="form.fCalcAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付金额">
              <el-input v-model="form.fPayAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="找零金额">
              <el-input v-model="form.fChgAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="红包发放时间">
              <el-input v-model="form.fChgTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="红包领用时间">
              <el-input v-model="form.fChgRcvTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="红包退回时间">
              <el-input v-model="form.fChgRetTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="扩展数据">
              <el-input v-model="form.fExtData"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.fRemark"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="fRemark_row">
          <el-col :span="24">
            <el-form-item label="支付参数">
              <el-input type="textarea"
                        v-model="form.fPayParmData"
                        :disabled="true"
                        class="fRemark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row class="fRemark_row_big">
          <el-col :span="24">
            <el-form-item label="支付返回参数">
              <el-input type="textarea"
                        v-model="form.fUrlRetData"
                        :disabled="true"
                        class="fRemark_big"></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="">
              <span :class="(form.fPayStatus=='1'?'success':'danger')"
                    style="font-size:20px;font-weight:bold;">
                {{'支付'+form.fPayStatusName}}
              </span>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer"
           class="dialog-footer">

        <span :class="(form.fPayStatus=='40'?'success':'danger')"
              style="font-size:20px;font-weight:bold;float:left;padding-left:100px">
          {{'红包'+form.fPayStatusName}}
        </span>

        <el-button type="success"
                   class="copy"
                   :data-clipboard-text='form.fPayParmData'
                   @click="copyData">复制支付参数</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import carInfoView from '../../components/carInfoView'
import roadSideCarInfoView from '../../components/roadSideCarInfoView'
import { report as api } from '../../api/report'
// import { cust as apiCust } from '../../api/cust'
import * as park from '../../api/park'
import * as user from '../../api/user'
import $ from 'jquery'
import Clipboard from 'clipboard'
export default {
  name: 'ePayList',
  components: { carInfoView, roadSideCarInfoView },
  data () {
    return {
      is_roadSide: false,
      payType_list: [],
      park_list: [],
      payMode_list: [
        { value: 'B2C', label: 'B2C:收费员扫码收款' },
        { value: 'C2BPay', label: 'C2BPay:车主出场扫码支付' },
        { value: 'C2BPre', label: 'C2BPre:车主场内扫码支付' },
        { value: 'C2BSPM', label: 'C2BSpm:缴费机场内支付' },
        { value: 'C2BPAP', label: 'C2BPAP:小程序无感扣费' }
      ],
      payStatus_list: [
        { value: 0, label: '红包未发放' },
        { value: 10, label: '红包发放中' },
        { value: 20, label: '已发放,待领取' },
        { value: 30, label: '发放失败' },
        { value: 40, label: '已领取' },
        { value: 50, label: '退款中' },
        { value: 60, label: '已退款' }
      ],
      dialogVisible: false,
      dialogTitle: '',
      title: '业务数据中心',
      form: {},
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      startTime: '',
      endTime: '',
      pageCount: 0,
      total: {
        totalChgAmt: 0,
        totalIssuedChgAmt: 0,
        totalReceivedChgAmt: 0
      },
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fParkID: '',
        fStartTime: '',
        fEndTime: '',
        fPlateCode: '',
        isExport: 0
      },
      startMonthOption: {
      },
      endMonthOption: {
      }
    }
  },
  methods: {
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      this.pageSearch.isExport = 0
      api.redPacketList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          // console.log(res)
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.totalCount
            this.total = { totalChgAmt: data.Data.totalChgAmt, totalIssuedChgAmt: data.Data.totalIssuedChgAmt, totalReceivedChgAmt: data.Data.totalReceivedChgAmt }
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
          } else {
            this.$message.error('提示：加载红包找零数据失败')
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      sums[0] = '合计：'
      sums[0] += '红包找零总额：' + this.total.totalChgAmt + ' | 已发放,待领取：' + this.total.totalIssuedChgAmt + ' | 已领取：' + this.total.totalReceivedChgAmt
      var dts = document.querySelectorAll('.el-table__footer-wrapper tbody.has-gutter>tr>td')
      if (dts && dts.length >= 6) {
        $(dts[0]).attr('colspan', 7)
        $(dts[0]).css('text-align', 'left')
      }
      return sums
    },
    loadPark (fCustID) {
      // 加载离场数据列表
      // this.page_list()
      this.pageSearch.fParkID = ''
      this.park_list = []

      if (!fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    copyData () {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        this.$message({
          message: '提示：复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message({
          message: '提示：该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    getCurrentMonthLast (dt) {
      var date = dt
      var currentMonth = date.getMonth()
      var nextMonth = ++currentMonth
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      var oneDay = 1000 * 60 * 60 * 24
      var lastTime = new Date(nextMonthFirstDay - oneDay)
      var month = parseInt(lastTime.getMonth() + 1)
      var day = lastTime.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return new Date(date.getFullYear() + '-' + month + '-' + day)
    },
    selectStartMonth () {
      var time = new Date()
      var endYear = this.endTime.getFullYear()
      var startYear = this.startTime.getFullYear()
      if (endYear !== startYear) {
        this.endTime = new Date(startYear, time.getMonth(), time.getDay(), 23, 59, 59)
      }
      this.endMonthOption = {
        disabledDate: (time) => {
          if (this.startTime !== '') {
            var year = this.startTime.getFullYear()
            return time.getTime() < this.startTime.getTime() || time.getFullYear() !== year
          }
        }
      }
    },
    selectEndMonth () {
      // var endMonth = this.endTime.getMonth()
      // var startMonth = this.startTime.getMonth()
      // if (endMonth !== startMonth) {
      //   this.startTime = new Date(this.endTime.getFullYear(), this.endTime.getMonth(), 1, 0, 0, 0)
      // }
      // this.startMonthOption = {
      //   disabledDate: (time) => {
      //     if (this.endTime !== '') {
      //       var endMonth = this.endTime.getMonth()
      //       var minMonth = time.getMonth()
      //       return time.getTime() > this.endTime.getTime() || endMonth > minMonth
      //     }
      //   }
      // }
    },
    exportData () {
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd 00:00:00')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd 23:59:59')
      this.pageSearch.isExport = 1
      this.pageSearch.fCustTypeID = this.is_roadSide ? 1 : 0
      this.export_loading = true
      this.export_msg = '导出中……'
      var fileName = '所有客户'
      if ((this.pageSearch.fCustID || '').trim().length > 0) {
        var custArr = (this.cust_list || []).filter((item) => {
          return item.fCustID === this.pageSearch.fCustID
        })
        fileName = custArr.length > 0 ? custArr[0].unionName : ''
      }
      api.redPacketList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_红包找零.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    init () {
      // var firstDay = new Date()
      // firstDay.setDate(1)
      // this.startTime = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate(), 0, 0, 0)
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
      // var type = this.$route.query.type
      // this.is_roadSide = type === '1'
      // if (this.is_roadSide) {
      //   this.title = '路测数据中心'
      // } else {
      //   this.title = '业务数据中心'
      // }
      this.selectStartMonth()
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.loadPark(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      // apiCust.allPayType().then(res => {
      //   if (res && res.data) {
      //     var data = res.data
      //     if (data.IsOk) {
      //       this.payType_list = data.Data || []
      //     } else {
      //       this.$message.error('提示：加载支付方式失败')
      //     }
      //   }
      // })
      user.getCurrentUserPers({ perTypeId: 69400 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_export = data.Data.data.is_export
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    },
    handleInfo (index, row) {
      this.$refs.child.handleInfo(row)
    },
    handleDetail (index, row) {
      this.form = row
      this.dialogTitle = '【' + row.fCustNo + '】' + row.fParkName + '-红包找零详情'
      this.dialogVisible = true
    },
    setImgHeight () {
      var formHeight = $('.form_right').height()
      var fplateHeight = $('.fplate_info .el-image').height()
      var carImgHeight = $('.car_img .img').height()
      if (formHeight && fplateHeight > 0) {
        var height = (formHeight - fplateHeight - carImgHeight) / 2
        $('.fplate_info').css({ 'margin-top': height + 'px', 'margin-bottom': height + 'px' })
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    }
  },
  created () {

  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        Object.assign(this.$data, this.$options.data())
        this.init()
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style >
/* dialog弹出框样式 */
#redPacketList .el-dialog {
  min-width: 840px;
}
#redPacketList .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#redPacketList .el-dialog__title {
  color: white;
}
#redPacketList .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#redPacketList .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
#redPacketList .fRemark > .el-textarea__inner {
  height: 100px;
}
#redPacketList .fRemark_row .el-form-item__content {
  height: 100px;
}
#redPacketList .fRemark_big > .el-textarea__inner {
  height: 135px;
}
#redPacketList .fRemark_row_big .el-form-item__content {
  height: 135px;
}
#redPacketList .el-input.is-disabled .el-input__inner,
#redPacketList .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/view/report/redPacketList.vue